import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { FEATURED_LOCATIONS, locationToSlug } from "../lib/locations";

function TrendingDestinations() {
  return (
    <div className="flex flex-wrap items-center gap-3">
      {FEATURED_LOCATIONS.map((loc) => (
        <Link
          key={loc}
          to={`/yoga-retreats-in/${locationToSlug(loc)}`}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-50 text-emerald-700 text-sm font-bold border border-emerald-100 hover:bg-emerald-100 hover:border-emerald-200 transition-colors"
        >
          <MapPin size={15} className="text-emerald-600" />
          {loc}
        </Link>
      ))}
    </div>
  );
}

export default TrendingDestinations;
